import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { ReadableCard, ReadableNavButton } from "../Sticker";
import { eventPublicPath } from "../../lib/eventLinks";
import { dismissFavouriteRsvp } from "../../lib/favouriteRsvpDismiss";

export default function FavouriteRsvpBanner({ item, onDismiss }) {
  if (!item?.is_today) return null;

  const ev = item.event || {};
  const path = eventPublicPath(ev, { occurrence_date: item.occurrence_date });

  function handleDismiss() {
    dismissFavouriteRsvp(item.event_id, item.occurrence_date);
    onDismiss?.();
  }

  return (
    <section className="max-w-page mx-auto px-4" data-testid="favourite-rsvp-banner">
      <ReadableCard className="relative p-4 pr-12 bg-plum/5 border-plum/20">
        <button
          type="button"
          onClick={handleDismiss}
          className="absolute top-2 right-2 rounded-md2 p-1.5 min-w-[32px] min-h-[32px] flex items-center justify-center text-ink/45 hover:text-ink/70 hover:bg-white/60"
          aria-label="Dismiss reminder"
          data-testid="favourite-rsvp-banner-dismiss"
        >
          <X className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
        </button>
        <p className="font-ui font-semibold text-[15px] text-ink/90">
          You haven&apos;t RSVP&apos;d to {ev.name || "an event you follow"} tonight.
        </p>
        <p className="font-ui font-medium text-[13px] text-ink/65 mt-1">
          Series you follow — tap to lock in your spot.
        </p>
        <ReadableNavButton
          as={Link}
          to={path}
          variant="primary"
          className="mt-3 min-h-[44px] px-4 text-[14px]"
          data-testid="favourite-rsvp-banner-cta"
        >
          RSVP now
        </ReadableNavButton>
      </ReadableCard>
    </section>
  );
}
